// Cronologia azioni di sessione con annulla/ripristina (solo in memoria)
let stack = [];
let redoStack = [];
const listeners = new Set();
const MAX_AGE_MS = 60 * 60 * 1000; // azioni più vecchie di 1 ora escono dalla cronologia
const emit = () => listeners.forEach((cb) => cb(stack.length, redoStack.length));

const prune = () => {
  const cut = Date.now() - MAX_AGE_MS;
  const n = stack.length;
  stack = stack.filter((e) => e.ts >= cut);
  if (stack.length !== n) emit();
};

export const pushUndo = (label, fn, redo) => {
  prune();
  stack.push({ label, fn, redo, ts: Date.now() });
  if (stack.length > 50) stack.shift();
  redoStack = [];
  emit();
};

export const undoLast = async () => {
  prune();
  const e = stack.pop();
  emit();
  if (!e) return null;
  await e.fn();
  if (e.redo) {
    redoStack.push({ ...e, ts: Date.now() });
    if (redoStack.length > 50) redoStack.shift();
  }
  emit();
  return e.label;
};

export const redoLast = async () => {
  const e = redoStack.pop();
  emit();
  if (!e) return null;
  await e.redo();
  stack.push({ ...e, ts: Date.now() });
  emit();
  return e.label;
};

export const undoCount = () => { prune(); return stack.length; };
export const redoCount = () => redoStack.length;
export const peekUndo = () => { prune(); return stack.length ? stack[stack.length - 1].label : null; };
export const peekUndoAge = () => { prune(); return stack.length ? Date.now() - stack[stack.length - 1].ts : null; };
export const peekRedo = () => (redoStack.length ? redoStack[redoStack.length - 1].label : null);
export const clearUndo = () => { stack = []; redoStack = []; emit(); };
export const subscribeUndo = (cb) => { listeners.add(cb); return () => listeners.delete(cb); };
